<script lang="ts" setup>
import './grid.scss';
import tile from '@/components/grid/tile.vue';
import loader from '@/components/grid/loader/loader.vue';

import { DEFAULT_LIMIT } from '@/api/performer/request';
import { usePerformerStore } from '@/stores/performer';
import { onMounted, watch, ref, computed, defineAsyncComponent } from 'vue';
import { useModalsStore } from '@/stores/modals';
import { useLocalizationStore } from '@/stores/localization';
import { storeToRefs } from 'pinia';
import { useRoute, type RouteLocationRaw } from 'vue-router';
import router from './../../router';
import { useUserStore } from '@/stores/user';
import { useMobileTeaserStore } from '@/stores/mobileTeaser';
import { debounce } from 'lodash-es';

const theme = ref(import.meta.env.VITE_Themename);

const pager = defineAsyncComponent(() => import('@/components/pager/pager.vue'));

const { marketing } = storeToRefs(useLocalizationStore());

const route = useRoute();
const page = ref(1);
const props = withDefaults( defineProps<{
    page: number;
    offset: number;
    limit: number;
    search?: string;
    category?: string;
    services?: string;
    ages?: string;
    gender?: string;
    sex?: string;
}>(), {page: 1, offset: 0, limit: DEFAULT_LIMIT} );

const store = usePerformerStore();
const { getActiveModal } = storeToRefs( useModalsStore() );
const performers = computed(() => store.getSlice('grid'));

const routeParams = computed(() => ({
    name: route.name!,
    query: {
        page: page.value,
        offset: (page.value - 1) * props.limit,
        limit: props.limit,
        search: props.search || undefined,
        services: props.services || undefined,
        ages: props.ages || undefined,
        gender: props.gender || undefined,
        sex: props.sex || undefined
    },
    params: { category: props.category }
}));

watch(props, load);
watch(page, debounce((newPage, oldPage) => {
    pageChange(newPage);
}, 250));

onMounted(load);

async function load() {
    const queryPage = route.query.page ? parseInt(route.query.page as string) : 1;
    if (page.value !== queryPage) {
        page.value = queryPage;
    }
    await store.loadSlice('grid', { ...props });
    store.currentSlice = 'grid';
    if (useUserStore().isMobile()) {
        //start timer on load..
        useMobileTeaserStore().startTimer();
    }
}

function pageChange(paged: number) {
    page.value = paged;
    router.push(routeParams.value);
}


</script>

<template src="./grid.html"></template>